import { deleteMethod, getMethod, postMethod, putMethod } from "../../api-service/api-service";
import {
    setColors,
    setLoading,
    addColor,
    updateColor,
    removeColor
} from "./colorSlice";

export const fetchColorAction = () => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const res = await getMethod("/color");
        if (res.success)
            dispatch(setColors(res?.data));
    } catch (err) {
        console.error(err);
    } finally {
        dispatch(setLoading(false));
    }
};

export const createColorAction = (payload) => async (dispatch) => {
    try {
        const res = await postMethod("/color", payload);
        if (res.success)
            dispatch(addColor(res?.data));
    } catch (err) {
        console.error(err);
    }
};

export const updateColorAction = (id, payload) => async (dispatch) => {
    try {
        const res = await putMethod(`/color/${id}`, payload);
        if (res.success)
            dispatch(updateColor(res?.data));
    } catch (err) {
        console.error(err);
    }
};

export const deleteColorAction = (id) => async (dispatch) => {
    try {
        const res = await deleteMethod(`/color/${id}`);
        if (res.success)
            dispatch(removeColor(id));
    } catch (err) {
        console.error(err);
    }
};
